import routes from './routes';

export default routes;
export * from './api/index';
export * from './Components/index';
export * from './Pages/index';
